import config from 'config';
import routes from 'constants/routes';

/**
 * Optional context carried through the PayPal redirect return_url so the
 * BillingReturnHandler knows which flow to resume on landing:
 *   - `add`    → attach-only (AddStripePaymentMethodModal)
 *   - `signup` → setup-subscription (SetupSubscriptionModal)
 * For card payments this is irrelevant — they resolve inline.
 */
export type StripeReturnContext =
  | { ctx: 'add'; billingEmail: string; holderName: string }
  | {
      ctx: 'signup';
      planId: string;
      cycle: string;
      billingEmail: string;
      holderName: string;
      couponCode?: string;
      address: string;
    };

export function buildReturnUrl(returnContext?: StripeReturnContext): string {
  const base = `${window.location.origin}${config.ROUTER_BASE_URL}${routes.SETTINGS.BILLING_RETURN}`;
  if (!returnContext) return base;

  const params = new URLSearchParams();
  params.set('ctx', returnContext.ctx);
  params.set('billingEmail', returnContext.billingEmail);
  params.set('holderName', returnContext.holderName);
  if (returnContext.ctx === 'signup') {
    params.set('planId', returnContext.planId);
    params.set('cycle', returnContext.cycle);
    if (returnContext.couponCode) {
      params.set('couponCode', returnContext.couponCode);
    }
    params.set('address', returnContext.address);
  }
  return `${base}?${params.toString()}`;
}
